export * from './user';
export * from './api';
export * from './tracking';
export { getDefaultShiftTimes, resolveContactHref, resolveAssetImage } from './util';
export { getContrastingTextColor, getContrastingTextClass } from './color';
export { resolveAppAdvertSlot, hasAppAdvert, buildAdvertorialPlacement } from './advertorial';

import { apiGetDocs } from '@/utils';
import store from '@/store';
import { bus } from '@/main';
import { resolveContactHref } from './util';

const locumPath = '/locum/profile';
const companyPath = '/company/profile';
const accountSettingPath = '/locum/account-settings';
const userManagementPath = '/company/user-management';

const getMenuLinks = (links, key, brandUrl = 'https://www.locumbase.com') => {
	if (key === 'contact') {
		return resolveContactHref(links, brandUrl);
	}
	return links && links[key] ? links[key] : `${brandUrl.replace(/\/$/, '')}/${key}`;
};

export const getNavItems = (userType, showWallet, invitesActive, links, brandUrl = 'https://www.locumbase.com') => [
	{
		title: 'Redeem Credits',
		icon: 'question_answer',
		hidden: userType === 'professional' || !showWallet,
		onClick: () => {
			bus.$emit('show-wallet-dialog');
		},
	},
	{
		title: 'Invite Locum',
		icon: 'question_answer',
		hidden: userType === 'professional' || !invitesActive,
		onClick: () => {
			bus.$emit('show-invite-popup');
		},
	},
	{ title: 'Edit Profile', icon: 'question_answer', to: userType === 'professional' ? locumPath : companyPath },
	{ title: 'Account Settings', icon: 'question_answer', to: accountSettingPath },
	{ title: 'User Management', icon: 'question_answer', to: userManagementPath, hidden: userType === 'professional' },
	{
		title: 'Preview Profile',
		icon: 'question_answer',
		hidden: userType !== 'professional',
		onClick: () => {
			bus.$emit('show-locum-preview-popup');
		},
	},
	{ title: 'FAQ', icon: 'question_answer', href: getMenuLinks(links, 'faq', brandUrl), target: '_blank' },
	{ title: 'Blog', icon: 'question_answer', href: getMenuLinks(links, 'blog', brandUrl), target: '_blank' },
	{ title: 'Contact Us', icon: 'question_answer', href: getMenuLinks(links, 'contact', brandUrl), target: '_blank' },
];

export const provinceRegionPairs = [
	{
		province: 'Gauteng',
		region: 'Bronkhorstspruit',
	},
	{
		province: 'Gauteng',
		region: 'Centurion',
	},
	{
		province: 'Gauteng',
		region: 'East Rand',
	},
	{
		province: 'Gauteng',
		region: 'Gauteng South and Midvaal',
	},
	{
		province: 'Gauteng',
		region: 'Johannesburg',
	},
	{
		province: 'Gauteng',
		region: 'Midrand',
	},
	{
		province: 'Gauteng',
		region: 'Pretoria',
	},
	{
		province: 'Gauteng',
		region: 'West Rand',
	},
	{
		province: 'Western Cape',
		region: 'Boland',
	},
	{
		province: 'Western Cape',
		region: 'Cape Town',
	},
	{
		province: 'Western Cape',
		region: 'Central Karoo',
	},
	{
		province: 'Western Cape',
		region: 'Garden Route',
	},
	{
		province: 'Western Cape',
		region: 'Overberg',
	},
	{
		province: 'Western Cape',
		region: 'West Coast',
	},
	{
		province: 'KwaZulu Natal',
		region: 'Dolphin Coast',
	},
	{
		province: 'KwaZulu Natal',
		region: 'Drakensberg',
	},
	{
		province: 'KwaZulu Natal',
		region: 'Durban',
	},
	{
		province: 'KwaZulu Natal',
		region: 'KZN Midlands',
	},
	{
		province: 'KwaZulu Natal',
		region: 'KZN North Coast',
	},
	{
		province: 'KwaZulu Natal',
		region: 'KZN South Coast',
	},
	{
		province: 'KwaZulu Natal',
		region: 'Northern KZN',
	},
	{
		province: 'KwaZulu Natal',
		region: 'Pietermaritzburg',
	},
	{
		province: 'Northern Cape',
		region: 'Kalahari and Green Kalahari',
	},
	{
		province: 'Northern Cape',
		region: 'Karoo',
	},
	{
		province: 'Northern Cape',
		region: 'Kimberley and Diamond Fields',
	},
	{
		province: 'Northern Cape',
		region: 'Namakwa',
	},
	{
		province: 'Free State',
		region: 'Bloemfontein',
	},
	{
		province: 'Free State',
		region: 'Eastern Free State',
	},
	{
		province: 'Free State',
		region: 'Northern Free State',
	},
	{
		province: 'Free State',
		region: 'Southern Free State',
	},
	{
		province: 'Free State',
		region: 'Welkom and Goldfields',
	},
	{
		province: 'Eastern Cape',
		region: 'East London to the Wild Coast',
	},
	{
		province: 'Eastern Cape',
		region: 'Eastern Cape Interior',
	},
	{
		province: 'Eastern Cape',
		region: 'Grahamstown',
	},
	{
		province: 'Eastern Cape',
		region: 'Jeffreys Bay to Tsitsikamma',
	},
	{
		province: 'Eastern Cape',
		region: 'Kenton On Sea',
	},
	{
		province: 'Eastern Cape',
		region: 'Port Alfred',
	},
	{
		province: 'Eastern Cape',
		region: 'Port Elizabeth and Nelson Mandela Bay',
	},
	{
		province: 'Limpopo',
		region: 'Bela-Bela and Bushveld',
	},
	{
		province: 'Limpopo',
		region: 'Burgersfort',
	},
	{
		province: 'Limpopo',
		region: 'Hoedspruit',
	},
	{
		province: 'Limpopo',
		region: 'Makhado and Vhembe District',
	},
	{
		province: 'Limpopo',
		region: 'Phalaborwa',
	},
	{
		province: 'Limpopo',
		region: 'Polokwane (Pietersburg)',
	},
	{
		province: 'Limpopo',
		region: 'Tzaneen and surrounds',
	},
	{
		province: 'North West',
		region: 'Brits',
	},
	{
		province: 'North West',
		region: 'Hartbeespoort Dam',
	},
	{
		province: 'North West',
		region: 'Klerksdorp',
	},
	{
		province: 'North West',
		region: 'North West',
	},
	{
		province: 'North West',
		region: 'Potchefstroom',
	},
	{
		province: 'North West',
		region: 'Rustenburg',
	},
	{
		province: 'North West',
		region: 'Vryburg',
	},
	{
		province: 'Mpumalanga',
		region: 'Highveld, Grass and Wetlands',
	},
	{
		province: 'Mpumalanga',
		region: 'Lowveld and Kruger Park',
	},
	{
		province: 'Mpumalanga',
		region: 'Middelburg',
	},
	{
		province: 'Mpumalanga',
		region: 'Witbank',
	},
];

export const getRelevantProfessions = (userProfile, industriesConfigsObj, { seeAllProfessionCategories = false } = {}) => {
	if (!industriesConfigsObj || Object.keys(industriesConfigsObj).length === 0) return [];

	if (seeAllProfessionCategories) {
		return Object.keys(industriesConfigsObj).reduce((all, industry) => {
			const professions = industriesConfigsObj[industry] || [];
			return all.concat(professions);
		}, []);
	}

	// For Pharmacy practices, locums required include Pharmacy & Nursing professions
	let nursingProfessions = [];
	if (userProfile === 'Pharmacy') {
		nursingProfessions = industriesConfigsObj['Nursing'] || [];
	}
	// For all other practices, locum professions required from relevant industry
	let professionOptions = industriesConfigsObj[userProfile] || [];

	return nursingProfessions.concat(professionOptions);
};

export const buildProfessionSelectItems = (userProfile, industriesConfigsObj, { seeAllProfessionCategories = false } = {}) => {
	if (!industriesConfigsObj || Object.keys(industriesConfigsObj).length === 0) return [];

	if (seeAllProfessionCategories) {
		const items = [];
		for (const [industry, professions] of Object.entries(industriesConfigsObj)) {
			const list = Array.isArray(professions) ? professions : professions?.professions?.map(p => p.name) || [];
			if (!list?.length) continue;
			items.push({ header: industry });
			items.push(...list);
		}
		return items;
	}

	const professions = getRelevantProfessions(userProfile, industriesConfigsObj);
	const nursingProfessions = industriesConfigsObj['Nursing'] || [];
	if (userProfile === 'Pharmacy' && nursingProfessions.length && professions.includes(nursingProfessions[0])) {
		const items = [...professions];
		const len = nursingProfessions.length;
		items.splice(len, 0, { header: userProfile });
		items.splice(len, 0, { divider: true });
		items.unshift({ header: 'Nursing' });
		return items;
	}

	if (!professions.length) return [];
	return [{ header: userProfile }, ...professions];
};

export const findProfessionConfig = (industriesV2, companyIndustry, professionName, { seeAllProfessionCategories = false } = {}) => {
	if (!industriesV2 || !professionName) return undefined;

	if (seeAllProfessionCategories) {
		for (const industry of Object.values(industriesV2)) {
			const found = industry?.professions?.find(({ name }) => name === professionName);
			if (found) return found;
		}
		return undefined;
	}

	return industriesV2[companyIndustry]?.professions?.find(({ name }) => name === professionName);
};

/**
 * Coded establishment types from Dynamo industry config (sorted by order).
 * @param {Record<string, any>} industriesV2
 * @param {string} industryName e.g. defaultIndustry 'Venue'
 */
export const getEstablishmentTypeOptions = (industriesV2, industryName) => {
	if (!industriesV2 || !industryName) return [];
	const types = industriesV2[industryName]?.establishmentTypes || [];
	return [...types].sort((a, b) => (a.order || 0) - (b.order || 0));
};

/**
 * Resolve establishment code (or legacy label) to display name.
 */
export const resolveEstablishmentTypeLabel = (codeOrName, industriesV2) => {
	if (!codeOrName) return '';
	for (const industry of Object.values(industriesV2 || {})) {
		const match = (industry.establishmentTypes || []).find(t => t.code === codeOrName || t.name === codeOrName);
		if (match) return match.name;
	}
	return codeOrName;
};

/** Industry names sorted by config `order` (skips empty-profession rows when excludeEmptyProfessions). */
export const getSortedIndustryNames = (industriesV2, { excludeEmptyProfessions = false } = {}) =>
	Object.keys(industriesV2 || {})
		.filter(name => {
			if (!excludeEmptyProfessions) return true;
			return (industriesV2[name]?.professions || []).length > 0;
		})
		.sort((a, b) => (industriesV2[a]?.order || 0) - (industriesV2[b]?.order || 0));

/** Flatten skill/option codes for a profession across all industries (for P4.3 role OR skill). */
export const getProfessionSkillCodes = (industriesV2, professionName) => {
	if (!industriesV2 || !professionName) return [];
	const codes = [];
	for (const industry of Object.values(industriesV2)) {
		const profession = (industry.professions || []).find(p => p.name === professionName);
		if (!profession?.skills) continue;
		for (const skill of profession.skills) {
			if (skill.options?.length) {
				for (const option of skill.options) {
					if (option.code) codes.push(option.code);
				}
			} else if (skill.code) {
				codes.push(skill.code);
			}
		}
	}
	return codes;
};

/**
 * Collect skills from all categories/professions (for cross-role additional skills).
 * Excludes the primary profession so seekers pick skills outside their primary role.
 */
export const collectCrossCategorySkills = (industriesV2, { excludeProfession = '' } = {}) => {
	if (!industriesV2) return [];

	const seen = new Set();
	const collected = [];
	const industryNames = getSortedIndustryNames(industriesV2, { excludeEmptyProfessions: true });

	for (const industryName of industryNames) {
		const professions = [...(industriesV2[industryName]?.professions || [])].sort((a, b) => (a.order || 0) - (b.order || 0));

		for (const profession of professions) {
			if (!profession?.name || profession.name === excludeProfession) continue;

			for (const skill of profession.skills || []) {
				if (skill.options?.length) {
					for (const option of skill.options) {
						if (!option?.code || seen.has(option.code)) continue;
						seen.add(option.code);
						collected.push({
							industryName,
							professionName: profession.name,
							code: option.code,
							name: `${skill.name} - ${option.name}`,
						});
					}
				} else if (skill?.code && !seen.has(skill.code)) {
					seen.add(skill.code);
					collected.push({
						industryName,
						professionName: profession.name,
						code: skill.code,
						name: skill.name || profession.name,
					});
				}
			}
		}
	}

	return collected;
};

/** Flat list for venue additional-skills selects: [{ code, name }]. */
export const flattenCrossCategorySkills = (industriesV2, { excludeProfession = '' } = {}) =>
	collectCrossCategorySkills(industriesV2, { excludeProfession }).map(({ code, name }) => ({ code, name }));

/**
 * Vuetify treeview items grouped by category for seeker Additional Skills.
 * Category parents are non-leaf; leaves are other roles' skill codes.
 */
export const buildCrossCategorySkillTreeItems = (industriesV2, selectedCodes = [], { excludeProfession = '' } = {}) => {
	const collected = collectCrossCategorySkills(industriesV2, { excludeProfession });
	if (!collected.length) return [];

	const byIndustry = new Map();
	for (const item of collected) {
		if (!byIndustry.has(item.industryName)) byIndustry.set(item.industryName, []);
		byIndustry.get(item.industryName).push(item);
	}

	const selected = selectedCodes || [];
	return [...byIndustry.entries()].map(([industryName, skills]) => {
		const children = skills.map(({ code, name }) => ({
			id: code,
			name,
			selected: selected.includes(code),
			allowMultiple: true,
			siblings: [],
		}));
		const optionSelected = children.some(child => child.selected);

		return {
			id: `cat:${industryName}`,
			name: industryName,
			children,
			selected: false,
			nodeActive: optionSelected,
			allowMultiple: true,
			siblings: [],
		};
	});
};

/** Worked-at options: prefer defaultIndustry (Venue) when it has options. */
export const getWorkedAtOptions = (industriesV2, userIndustry, defaultIndustry = '') => {
	if (!industriesV2) return [];
	const preferred = defaultIndustry && industriesV2[defaultIndustry];
	if (preferred?.workedAtOptions?.length) return preferred.workedAtOptions;
	return industriesV2[userIndustry]?.workedAtOptions || [];
};

export const getAllIndustriesProfessions = industriesConfigsObj => {
	let allProfessions = [];
	const listOfIndustries = Object.keys(industriesConfigsObj);
	for (const industry of listOfIndustries) {
		allProfessions.push({ industry: industry, expertise: 'not specified' });
		let professions = industriesConfigsObj[industry];
		for (const profession of professions) {
			allProfessions.push({ industry: industry, expertise: profession });
		}
	}
	allProfessions.push({ industry: 'not specified', expertise: 'not specified' });
	return allProfessions;
};

export const getLocumAvatar = async userId => {
	let logo = '';
	try {
		const response = await apiGetDocs('images/avatar/' + userId);
		logo = 'data:image/png;base64,' + response.data.data;
	} catch (err) {
		console.error('Error msg: ', err);
	}
	return logo;
};

export const getProfileProgressPercentage = () => {
	// let total = store.getters.stepsRequired.length + store.getters.stepsBoosted.length;
	let count = 0;
	store.getters.stepsRequired.forEach(step => {
		if (step.status) {
			count++;
		}
	});
	store.getters.stepsBoosted.forEach(step => {
		if (step.status) {
			count++;
		}
	});
	return Math.min(100, count * 10 + 10 + (store.getters.getIsApproved ? 10 : 0) + (store.getters.currentStep == 'completed-step' ? 10 : 0)); //+10 for initial step thats guarenteed to be done
};
